import React from "react";

export const Tower = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        opacity="0.148446"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 9.6001H6V20.0001H4V9.6001Z"
        fill="#4BCFFF"
      />
      <path
        opacity="0.148446"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.2 9.6001H13.2V20.0001H11.2V9.6001Z"
        fill="#4BCFFF"
      />
      <path
        opacity="0.148446"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 9.6001H20V20.0001H18V9.6001Z"
        fill="#4BCFFF"
      />
      <path
        d="M21.8906 9.89061C22.0771 9.89061 22.256 9.8165 22.3878 9.68464C22.5528 9.51964 24 8.02484 24 6.37498C24 6.11065 23.8495 5.86611 23.6123 5.74662L12.3155 0.0747423C12.117 -0.0249141 11.883 -0.0249141 11.6845 0.0747423L0.387609 5.74662C0.15525 5.86372 0 6.10634 0 6.37498C0 8.02452 1.44652 9.51899 1.61208 9.68455C1.74764 9.8202 1.93317 9.89061 2.10938 9.89061H2.8125V19.7812H2.10938C1.92286 19.7812 1.74403 19.8554 1.61222 19.9872C1.44717 20.1522 0 21.647 0 23.2969C0 23.6852 0.314813 24 0.703125 24H23.2969C23.6852 24 24 23.6852 24 23.2969C24 21.647 22.5528 20.1522 22.3878 19.9872C22.256 19.8553 22.0771 19.7812 21.8906 19.7812H21.1875V9.89061H21.8906ZM12 1.4899L20.3294 5.67186H3.67064L12 1.4899ZM21.5816 21.1875C21.8577 21.5096 22.2445 22.0408 22.4508 22.5937H1.54912C1.75556 22.0406 2.14261 21.5091 2.41833 21.1875H21.5816ZM4.21875 19.7812V9.89061H5.625V19.7812H4.21875ZM7.03125 19.7812V9.89061H9.89062V19.7812H7.03125ZM11.2969 19.7812V9.89061H12.7031V19.7812H11.2969ZM14.1094 19.7812V9.89061H16.9688V19.7812H14.1094ZM18.375 19.7812V9.89061H19.7812V19.7812H18.375ZM2.41842 8.48436C2.14233 8.16228 1.75561 7.63105 1.54927 7.07764H22.4506C22.2442 7.63133 21.8574 8.16275 21.5817 8.48436H2.41842Z"
        fill="#3377FF"
      />
      <path
        d="M2.8125 9.89062V19.7813H21.1875V9.89062H2.8125ZM4.21875 19.7813V9.89062H5.625V19.7813H4.21875ZM7.03125 19.7813V9.89062H9.89062V19.7813H7.03125ZM11.2969 19.7813V9.89062H12.7031V19.7813H11.2969ZM14.1094 19.7813V9.89062H16.9688V19.7813H14.1094ZM18.375 19.7813V9.89062H19.7812V19.7813H18.375Z"
        fill="#4BCFFF"
      />
    </svg>
  );
};
